export default __webpack_public_path__ + "static/media/cancel.683b03d3.svg";